import { define } from 'wicked-elements'
import Player from '@vimeo/player'
import onIntersect from 'on-intersect'

define('[data-component~="auto-vimeo"]', {
  init () {
    this.$player = this.element.querySelector('iframe')
    this.player = new Player(this.$player, {
      controls: false,
      title: false,
      byline: false
    })
    this.player.setVolume(0)
    this.player.setLoop(true)
    this.player.play()

    this.onEnter = this.onEnter.bind(this)
    this.onLeave = this.onLeave.bind(this)
  },
  connected () {
    this.stopObserving = onIntersect(this.element, {}, this.onEnter, this.onLeave)
  },
  disconnected () {
    this.stopObserving()
  },
  onEnter () {
    this.player.play()
  },
  onLeave () {
    this.player.pause()
  }
})